module.exports = __webpack_public_path__ + "img/itx-arrow-first.e249cfe1.svg";